import ControlledFormInput from './ControlledFormInput';

export default ControlledFormInput;
